module.exports = __webpack_public_path__ + "media/audio18.34800c9a.mp3";